import React from "react";
import { Buildings2, CalendarDate, CalendarMark, City, ClipboardList, ClipboardText, GraphUp, HeartBroken, MapPoint, PieChart, Ranking, ShieldCheck, UserBlock, UserId, UserRounded, UsersGroupRounded, UsersGroupTwoRounded, } from "@solar-icons/react";
function resolveSolarIcon(icon) {
    return (icon && "default" in icon ? icon.default : icon);
}
var CalendarDateIcon = resolveSolarIcon(CalendarDate);
var CalendarMarkIcon = resolveSolarIcon(CalendarMark);
var Buildings2Icon = resolveSolarIcon(Buildings2);
var CityIcon = resolveSolarIcon(City);
var ClipboardListIcon = resolveSolarIcon(ClipboardList);
var ClipboardTextIcon = resolveSolarIcon(ClipboardText);
var GraphUpIcon = resolveSolarIcon(GraphUp);
var HeartBrokenIcon = resolveSolarIcon(HeartBroken);
var MapPointIcon = resolveSolarIcon(MapPoint);
var PieChartIcon = resolveSolarIcon(PieChart);
var RankingIcon = resolveSolarIcon(Ranking);
var ShieldCheckIcon = resolveSolarIcon(ShieldCheck);
var UserBlockIcon = resolveSolarIcon(UserBlock);
var UserIdIcon = resolveSolarIcon(UserId);
var UserRoundedIcon = resolveSolarIcon(UserRounded);
var UsersGroupRoundedIcon = resolveSolarIcon(UsersGroupRounded);
var UsersGroupTwoRoundedIcon = resolveSolarIcon(UsersGroupTwoRounded);
var COLORS = {
    blue: "#1565C0",
    wine: "#7B1535",
    green: "#007932",
    gold: "#B8860B",
    purple: "#5B21B6",
};
function bindSolarIcon(IconComponent, weight, displayName) {
    function BoundKpiIcon(props) {
        var sx = props.sx && typeof props.sx === "object" && !Array.isArray(props.sx)
            ? props.sx
            : {};
        var color = typeof props.color === "string"
            ? props.color
            : typeof sx.color === "string"
                ? sx.color
                : "currentColor";
        var size = typeof props.fontSize === "number" || typeof props.fontSize === "string"
            ? props.fontSize
            : typeof sx.fontSize === "number" || typeof sx.fontSize === "string"
                ? sx.fontSize
                : 22;
        return React.createElement(IconComponent, {
            color: color,
            size: size,
            weight: weight,
            className: typeof props.className === "string" ? props.className : undefined,
            style: props.style && typeof props.style === "object"
                ? props.style
                : undefined,
        });
    }
    BoundKpiIcon.displayName = displayName;
    return BoundKpiIcon;
}
function createVisual(IconComponent, toneColor, displayName, weight) {
    if (weight === void 0) { weight = "BoldDuotone"; }
    return {
        Icon: bindSolarIcon(IconComponent, weight, displayName),
        iconBg: toneColor,
        detailColor: toneColor,
    };
}
export var DEFAULT_KPI_CARD_VISUALS = createVisual(ClipboardTextIcon, COLORS.blue, "default-kpi-icon");
var KPI_VISUALS_BY_ID = {
    "mulheres.visao_geral.kpi.total_feminicidios": createVisual(HeartBrokenIcon, COLORS.blue, "mulheres-total-feminicidios"),
    "mulheres.visao_geral.kpi.total_bos": createVisual(ClipboardListIcon, COLORS.green, "mulheres-total-bos"),
    "mulheres.visao_geral.kpi.ano_atual": createVisual(CalendarMarkIcon, COLORS.purple, "mulheres-ano-atual"),
    "mulheres.visao_geral.kpi.municipio_critico": createVisual(CityIcon, COLORS.wine, "mulheres-municipio-critico"),
    "mulheres.visao_geral.kpi.territorio_critico": createVisual(MapPointIcon, COLORS.gold, "mulheres-territorio-critico"),
    "mulheres.perfil_vitimas.kpi.perfil_predominante": createVisual(UserRoundedIcon, COLORS.blue, "mulheres-perfil-predominante"),
    "mulheres.perfil_vitimas.kpi.faixa_etaria_predominante": createVisual(UserIdIcon, COLORS.wine, "mulheres-faixa-etaria"),
    "mulheres.perfil_vitimas.kpi.raca_parda_percentual": createVisual(UsersGroupTwoRoundedIcon, COLORS.purple, "mulheres-raca-parda-percentual"),
    "mulheres.perfil_vitimas.kpi.companheiro_ex_percentual": createVisual(HeartBrokenIcon, COLORS.gold, "mulheres-companheiro-ex-percentual"),
    "mulheres.perfil_vitimas.kpi.casos_residencia_percentual": createVisual(Buildings2Icon, COLORS.green, "mulheres-casos-residencia-percentual"),
    "mulheres.feminicidios.kpi.total_feminicidios": createVisual(HeartBrokenIcon, COLORS.blue, "mulheres-feminicidios-total"),
    "mulheres.feminicidios.kpi.ano_pico_feminicidios": createVisual(GraphUpIcon, COLORS.wine, "mulheres-feminicidios-pico", "LineDuotone"),
    "mulheres.feminicidios.kpi.municipio_critico": createVisual(CityIcon, COLORS.green, "mulheres-feminicidios-municipio-critico"),
    "mulheres.feminicidios.kpi.territorio_critico": createVisual(MapPointIcon, COLORS.gold, "mulheres-feminicidios-territorio-critico"),
    "mulheres.feminicidios.kpi.instrumento_predominante": createVisual(ClipboardListIcon, COLORS.purple, "mulheres-feminicidios-instrumento"),
    "mulheres.tempo_territorio.kpi.total_ocorrencias": createVisual(CalendarDateIcon, COLORS.blue, "mulheres-total-ocorrencias"),
    "mulheres.tempo_territorio.kpi.dia_mais_critico": createVisual(CalendarMarkIcon, COLORS.wine, "mulheres-dia-mais-critico"),
    "mulheres.tempo_territorio.kpi.turno_mais_critico": createVisual(GraphUpIcon, COLORS.gold, "mulheres-turno-mais-critico"),
    "mulheres.tempo_territorio.kpi.municipios_monitorados": createVisual(CityIcon, COLORS.green, "mulheres-municipios-monitorados"),
    "mulheres.tempo_territorio.kpi.municipio_mais_registros": createVisual(MapPointIcon, COLORS.purple, "mulheres-municipio-mais-registros"),
    "mulheres.bos_deams.kpi.ocorrencias_mes": createVisual(CalendarDateIcon, COLORS.blue, "mulheres-ocorrencias-mes"),
    "mulheres.bos_deams.kpi.acumulado_ano": createVisual(CalendarMarkIcon, COLORS.green, "mulheres-acumulado-ano"),
    "mulheres.bos_deams.kpi.media_mensal_historica": createVisual(GraphUpIcon, COLORS.wine, "mulheres-media-mensal", "LineDuotone"),
    "mulheres.bos_deams.kpi.participacao_estado": createVisual(PieChartIcon, COLORS.gold, "mulheres-participacao-estado"),
    "mulheres.bos_deams.kpi.ranking_estadual": createVisual(RankingIcon, COLORS.purple, "mulheres-ranking-estadual"),
    "disque100.denuncias.kpi.max_year": createVisual(GraphUpIcon, COLORS.green, "disque100-denuncias-max-year", "LineDuotone"),
    "disque100.denuncias.kpi.top_group": createVisual(UserBlockIcon, COLORS.wine, "disque100-denuncias-top-group"),
    "disque100.denuncias.kpi.bottom_group": createVisual(ShieldCheckIcon, COLORS.gold, "disque100-denuncias-bottom-group"),
    "disque100.denuncias.kpi.period_total": createVisual(ClipboardTextIcon, COLORS.green, "disque100-denuncias-period-total"),
    "disque100.denuncias.kpi.period_top_group": createVisual(UserBlockIcon, COLORS.wine, "disque100-denuncias-period-top-group"),
    "disque100.denuncias.kpi.period_bottom_group": createVisual(ShieldCheckIcon, COLORS.gold, "disque100-denuncias-period-bottom-group"),
    "disque100.vitimas.kpi.max_year": createVisual(GraphUpIcon, COLORS.green, "disque100-vitimas-max-year", "LineDuotone"),
    "disque100.vitimas.kpi.top_group": createVisual(UserBlockIcon, COLORS.wine, "disque100-vitimas-top-group"),
    "disque100.vitimas.kpi.bottom_group": createVisual(ShieldCheckIcon, COLORS.gold, "disque100-vitimas-bottom-group"),
    "disque100.vitimas.kpi.period_total": createVisual(UsersGroupRoundedIcon, COLORS.green, "disque100-vitimas-period-total"),
    "disque100.vitimas.kpi.period_top_group": createVisual(UserBlockIcon, COLORS.wine, "disque100-vitimas-period-top-group"),
    "disque100.vitimas.kpi.period_bottom_group": createVisual(ShieldCheckIcon, COLORS.gold, "disque100-vitimas-period-bottom-group"),
    "disque100.violacoes.kpi.max_year": createVisual(GraphUpIcon, COLORS.blue, "disque100-violacoes-max-year", "LineDuotone"),
    "disque100.violacoes.kpi.top_group": createVisual(UserBlockIcon, COLORS.wine, "disque100-violacoes-top-group"),
    "disque100.violacoes.kpi.bottom_group": createVisual(ShieldCheckIcon, COLORS.gold, "disque100-violacoes-bottom-group"),
    "disque100.violacoes.kpi.period_total": createVisual(ClipboardListIcon, COLORS.blue, "disque100-violacoes-period-total"),
    "disque100.violacoes.kpi.period_top_group": createVisual(UserBlockIcon, COLORS.wine, "disque100-violacoes-period-top-group"),
    "disque100.violacoes.kpi.period_bottom_group": createVisual(ShieldCheckIcon, COLORS.gold, "disque100-violacoes-period-bottom-group"),
    "disque100.outros.kpi.top_location": createVisual(MapPointIcon, COLORS.blue, "disque100-outros-top-location"),
    "disque100.outros.kpi.top_city": createVisual(Buildings2Icon, COLORS.wine, "disque100-outros-top-city"),
};
export function getKpiCardVisuals(kpiId) {
    var _a;
    if (!kpiId) {
        return DEFAULT_KPI_CARD_VISUALS;
    }
    return (_a = KPI_VISUALS_BY_ID[kpiId]) !== null && _a !== void 0 ? _a : DEFAULT_KPI_CARD_VISUALS;
}
